import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useMemberAssessmentStore = defineStore('memberAssessment', () => {
    const activeAssessments = ref(null);
    const currentAssessment = ref(null);
    const locale = ref('en');

    // Assessment flow state
    const currentFlowHash = ref(null);
    const flowQuestions = ref([]);
    const flowQuestionIndex = ref(0);
    const loadingFlowQuestions = ref(false);

    const reset = () => {
        activeAssessments.value = null;
    };

    const resetAssessmentFlow = () => {
        currentFlowHash.value = null;
        flowQuestions.value = [];
        flowQuestionIndex.value = 0;
        loadingFlowQuestions.value = false;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/member-assessments', { params }),
        store: (params) => axios.post('/api/v1/member-assessments', params),

        update: async (params) => {
            const res = await axios.patch('/api/v1/member-assessments/' + params.hash, params);
            return res.data;
        },

        submit: async (params) => {
            const res = await axios.post('/api/v1/member-assessments/' + params.hash + '/submit');
            return res.data;
        },

        destroy: (params) => axios.delete('/api/v1/member-assessments/' + params.hash),
        
        loadQuestionsAndResponses: (params) => axios.get('/api/v1/member-assessments/' + params.hash + '/load-questions-responses'),

        loadAssessmentFlow: async (hash) => {
            currentFlowHash.value = hash;
            flowQuestions.value = [];
            flowQuestionIndex.value = 0;
            loadingFlowQuestions.value = true;

            try {
                const res = await axios.get('/api/v1/member-assessments/' + hash + '/load-questions-responses');

                // Prevent an old request from replacing the latest assessment flow.
                if (currentFlowHash.value !== hash) {
                    return;
                }

                flowQuestions.value = res.data.questions_responses ?? [];
            } finally {
                if (currentFlowHash.value === hash) {
                    loadingFlowQuestions.value = false;
                }
            }
        },

        saveQuestionsResponses: async (params) => {
            const res = await axios.patch('/api/v1/member-assessments/' + params.hash + '/save-questions-responses', params);
            return res.data;
        },

    };

    const setLocale = (option) => {
        locale.value = option;
        window.axios.post('/set-locale', { locale: option });
    };

    return {
        activeAssessments,
        currentAssessment,
        locale,
        currentFlowHash,
        flowQuestions,
        flowQuestionIndex,
        loadingFlowQuestions,
        setLocale,
        reset,
        resetAssessmentFlow,
        ...actions,
    };
});
